import React, { useEffect } from 'react';

export default function Nosotros() {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const manejarCambioClase = (event) => {
      const time1 = document.getElementById('time-1');
      const time3 = document.getElementById('time-3');
      const hr1 = document.getElementById('hr-1');
      const hr3 = document.getElementById('hr-3');

      if (time1 && time3 ) {
        if (event.matches) {
          // Si el tamaño es móvil
          time1.classList.add('timeline-end');
          time3.classList.add('timeline-end');

          time1.classList.remove('timeline-start');
          time3.classList.remove('timeline-start');

          hr1.classList.add('hr-horizontal-right');
          hr3.classList.add('hr-horizontal-right');

          hr1.classList.remove('hr-horizontal-left');
          hr3.classList.remove('hr-horizontal-left');
        } else {
          // Si el tamaño no es móvil
          time1.classList.add('timeline-start');
          time3.classList.add('timeline-start');

          time1.classList.remove('timeline-end');
          time3.classList.remove('timeline-end');



          hr1.classList.add('hr-horizontal-left');
          hr3.classList.add('hr-horizontal-left');

          hr1.classList.remove('hr-horizontal-right');
          hr3.classList.remove('hr-horizontal-right');
        }
      }
    };

    // Escuchar cambios de tamaño
    mediaQuery.addEventListener('change', manejarCambioClase);

    // Ejecutar al cargar
    manejarCambioClase(mediaQuery);

    // Cleanup: eliminar el listener
    return () => {
      mediaQuery.removeEventListener('change', manejarCambioClase);
    };
  }, []);

  return (
    <section id="nosotros" className="about-section bg-base-100 py-16">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 style={{ textAlign: 'left' }} className="text-3xl md:text-4xl lg:text-5xl font-bold">
            Nuestra Historia de Innovación
          </h1>
        </div>

        <div>
          <ul className="timeline timeline-vertical">
            <li className="fade-in-on-scroll">
              <hr />
              <div id="time-1" className="timeline-start timeline-box">
                <h1 className="timeline-h1">2017: Fundación</h1>
                <hr id='hr-1' className="hr-horizontal-left" />
                <p className="timeline-p">
                  Iwie agro nace con la visión de revolucionar la agricultura mediante la tecnología.
                </p>
              </div>
              <div className="timeline-middle">1</div>
              <hr />
            </li>
            <li className="fade-in-on-scroll">
              <hr />
              <div className="timeline-middle">2</div>
              <div className="timeline-end timeline-box">
                <h1 className="timeline-h1">2022: Consolidación del equipo</h1>
                <hr className="hr-horizontal-right" />
                <p className="timeline-p">Se juntó y se consolidó el equipo de Iwie Agro.</p>
              </div>
              <hr />
            </li>
            <li className="fade-in-on-scroll">
              <hr />
              <div id="time-3" className="timeline-start timeline-box">
                <h1 className="timeline-h1">2023: Primeros servicios</h1>
                <hr id='hr-3' className="hr-horizontal-left" />
                <p className="timeline-p">
                  Adquirimos el primer dron y comenzamos los servicios de pulverización con drones.
                </p>
              </div>
              <div className="timeline-middle">3</div>
              <hr />
            </li>
            <li className="fade-in-on-scroll">
              <hr />
              <div className="timeline-middle">4</div>
              <div className="timeline-end timeline-box">
                <h1 className="timeline-h1">2024: Establecimiento en el mercado</h1>
                <hr className="hr-horizontal-right" />
                <p className="timeline-p">
                  Iwie Agro se consolida en el mercado como una empresa líder a nivel país.
                </p>
              </div>
              <hr />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
